import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import ButtonViewStyle from './ButtonViewStyle';
import ButtonViewModel from './ButtonViewModel';
import { Text, TouchableWithoutFeedback, Animated } from 'react-native';
import LottieView from '../Lottie/LottieView';
export default class ButtonView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new ButtonViewModel(this), new ButtonViewStyle(this));
    }
    /* RENDERING */
    render() {
        const opacity = this.state.opacity.interpolate({
            inputRange: [0, 1],
            outputRange: [0.7, 1],
        });
        const translateX = this.state.buttonTranslateX.interpolate({
            inputRange: [0, 1],
            outputRange: [4, 0],
        });
        const translateY = this.state.buttonTranslateY.interpolate({
            inputRange: [0, 1],
            outputRange: [4, 0],
        });
        const widthShadow = this.state.buttonTranslateX.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 3],
        });
        const heightShadow = this.state.buttonTranslateY.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 3],
        });
        return (React.createElement(TouchableWithoutFeedback, { onPress: () => { this.props.isLoading == false && this.binding.handleOnPress(); } },
            React.createElement(Animated.View, { style: [{ backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : '#007bff' },
                    this.props.style != undefined ? this.props.style :
                        this.binding.getMyStyle(),
                    { transform: [{ scaleX: this.state.scale }, { scaleY: this.state.scale }], },
                    { opacity: opacity },
                    this.props.animation == "Button" && ([{ shadowOffset: { width: widthShadow, height: heightShadow } }, { transform: [{ translateY: translateY }, { translateX: translateX }], }])
                ] }, this.props.isLoading ? (React.createElement(LottieView, { height: 25, width: 40, source: require('./assets/btn_loading.json') }))
                :
                    (React.createElement(Text, { style: { color: this.props.textColor != undefined ? this.props.textColor : 'white' } }, this.props.children)))));
    }
}
